import type {
  CompanyContact,
  CreateCompanyContactRequest,
  UpdateCompanyContactRequest
} from '@tandemone/types'
import { createContext } from 'react'

export type BusinessContactsFormContextValue = {
  handleContinue: () => void
  addRow: (draft: CreateCompanyContactRequest) => Promise<CompanyContact>
  updateRow: (id: string, patch: UpdateCompanyContactRequest) => Promise<void>
  removeRow: (id: string) => Promise<void>
}

export const BusinessContactsFormContext =
  createContext<BusinessContactsFormContextValue | null>(null)
